/* eslint-disable array-callback-return */
import {
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonPage,
  IonRow,
  useIonToast,
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import Header from "src/components/Header";
import Autocomplete from "src/components/Autocomplete";
import DatePicker from "src/components/DatePicker";
import Select from '@material-ui/core/Select';
import { Button, TextField, Typography, FormControl, MenuItem, makeStyles, createStyles, Theme } from "@material-ui/core";
import TimePicker from "src/components/TimePicker";
import HistorialAPI from "src/services/historial";
import { useParams, withRouter } from "react-router";
import HelperText from "src/components/HelperText";
import {
  opcionAPuntoServicio,
  fechaConHora,
  checkearValidezEntradaSalida,
  checkearValidezDeCorte,
  InputEstado,
  PuntoServicio,
  Opcion,
  InputValidez,
  ReclamoProps,
  Corte,
  TipoReclamo,
  ReclamoProceso,
} from "src/utils";
import {ReclamosAPI} from "src/services/reclamos";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 300,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }),
);

// estado inicial valido para la interfaz InputValidez
const estadoValido = {
  valido: true,
  info: "",
};
// estado inicial invalido para la interfaz InputValidez
const estadoInvalido = {
  valido: false,
  info: "",
};
// estado inicial de los tres posibles cortes
const estadoInicialCortes = [
  { ...estadoInvalido },
  { ...estadoInvalido },
  { ...estadoInvalido },
  { ...estadoInvalido },
];

const hoy = new Date();

const ReclamoDetalles: React.FC<ReclamoProps> = (props: ReclamoProps) => {
  /***********************************************************
   * 1. variables que definen el estado de la pagina. inicio *
   ***********************************************************/
  const classes = useStyles();
  const [mostrarComentario, setMostrarComentario] = useState(false);
  const [puntoServicio, setPuntoServicio] = useState<
    InputEstado<PuntoServicio>
  >({ ...estadoInvalido });
  const [fechaInicio, setFechaInicio] = useState<InputEstado<Date>>({
    ...estadoInvalido,
  });
  const [cortes, setCortes] =
    useState<InputEstado<Corte>[]>(estadoInicialCortes);
  const [mostarCorte2, setMostrarCorte2] = useState(false);
  const [mostarCorte3, setMostrarCorte3] = useState(false);
  const [mostarCorte4, setMostrarCorte4] = useState(false);
  const [razon, setRazon] = useState<string>("")
  const [comentario, setComentario] = useState("");
  const [operacionEnProceso, setOperacionEnProceso] = useState(false);
  const [estadoReclamo, setEstadoReclamo] = useState("ACEPTADO");
  // present crea las notificaciones Toast
  const [present] = useIonToast();

  // history permite redireonar la pagina
  const history = props.history;
  // id de la marcacion
  const { id } = useParams<any>();
  const accionDelOperario = id ? "cambiar" : "crear";
  const crearDesdeCero = !id;

  /******************************************************************
   * 2. funciones para procesar la carga y actualizacion del estado *
   ******************************************************************/

  const params = props.location.search.split("&");

  const tipo = params
    .find((param) => param.includes("tipo="))
    ?.split("tipo=")[1] as TipoReclamo;
  const pageFrom = params
    .find((param) => param.includes("pageFrom="))
    ?.split("pageFrom=")[1];

  const cargoLower = (props.cargo ?? "").toLowerCase();
  // Regla de negocio: SUPERVISOR debe poder reclamar horas igual que OPERARIO.
  const esOperario = cargoLower.includes("ope") || cargoLower.includes("supervisor");
  const esFiscal = cargoLower.includes("fiscal");
  const estadoFinal = estadoReclamo === "ACEPTADO" || estadoReclamo === "RECHAZADO";

  const fuenteDeDatos =
    pageFrom === "/historial-de-trabajo" ? "marcacion" : "reclamo";

  const modoSoloVistaGeneral = estadoFinal;
  const modoEdicionGeneral = !estadoFinal;

  const esCargaDeFiscal = esFiscal && estadoReclamo === "ABIERTO";
  const esCargaDeOperario = modoEdicionGeneral && !esCargaDeFiscal;
  const modoVistaDeOperario = !modoEdicionGeneral;
  const habilitarPSyFecha = modoEdicionGeneral;

 
  // cada vez que entramos a la vista, precargamos los datos
  useEffect(() => {
    limpiarCampos();
    if (!crearDesdeCero) cargarDatosDeMarcacion(parseInt(id));
    else setEstadoReclamo("NUEVO");
  }, [id]);

  // precargamos el punto de servicio, fecha y entrada-salida de la marcacion
  // por ahora, solo cargamos la marcacion inicial, no cargamos los datos del reclamo ya creado
  const cargarDatosDeMarcacion = (idEntidad: number) => {
    // llamamos al servicio que nos retorna datos de la marcacion
    if (fuenteDeDatos === "marcacion") {
      cargarDatosParaReclamoNuevo(idEntidad, tipo); // cargamos una marcacion, ya que aun no existe el reclamo
    } else {
      cargarDatosDeReclamoExistente(idEntidad); // cargamos el reclamo existente
    }
  };

  const cargarDatosParaReclamoNuevo = (
    marcacionID: number,
    tipo: TipoReclamo
  ) => {
    HistorialAPI.marcacion(marcacionID, tipo)
      // si la llamada a la API termino sin problemas
      .then((result) => {
        const marcacion = result;

        // convertimos las horas en minutos y agregamos a un Date con fecha de la marcacion
        const horaEntrada = fechaConHora(
          marcacion.fecha,
          marcacion.horaEntrada
        );
        const horaSalida = fechaConHora(marcacion.fecha, marcacion.horaSalida);

        // cargamos el estado del autocomplete para punto de servicio
        const puntoDeServicio = marcacion.puntoServicio;
        const estadoPuntoServicio = {
          valor: puntoDeServicio,
          valido: puntoDeServicio ? true : false,
          info: puntoDeServicio ? "" : "El Punto de Servicio es obligatorio",
        };

        // cargamos el estado de la fecha de la marcacion
        const estadoFechaInicio = {
          valor: marcacion.fecha,
          valido: marcacion.fecha ? true : false,
          info: marcacion.fecha ? "" : "La fecha es obligatoria",
        };

        // cargamos el primer corte de la marcacion
        const corte = {
          horaEntrada: horaEntrada,
          horaSalida: horaSalida,
        };
        // calculamos el estado del corte
        const validezDeHoras = checkearValidezEntradaSalida(
          horaEntrada,
          horaSalida
        );
        // cargamos el corte con su estado al estado general de la pagina
        const nuevosCortes = cortes.slice();
        nuevosCortes[0] = { valor: corte, ...validezDeHoras };

        // actualizamos el estado de la pagina con los valores calculados arriba
        setPuntoServicio(estadoPuntoServicio);
        setFechaInicio(estadoFechaInicio);
        setCortes(nuevosCortes);
        setEstadoReclamo("NUEVO");
      })
      // si hubo algun error en la llamada a la API
      .catch((error) => {
        // presentamos el error con un Toast
        present({
          message: error.response ? error.response.data.error : error,
          duration: 5000,
        });
      });
  };

  const cargarDatosDeReclamoExistente = (reclamoID: number) => {
    ReclamosAPI.verReclamo(reclamoID)
      // si la llamada a la API termino sin problemas
      .then((result) => {
        const reclamo = result;

        // cargamos el estado del autocomplete para punto de servicio
        const puntoDeServicio = reclamo.puntoServicio;
        const estadoPuntoServicio = {
          valor: puntoDeServicio,
          valido: puntoDeServicio ? true : false,
          info: puntoDeServicio ? "" : "El Punto de Servicio es obligatorio",
        };

        // cargamos el estado de la fecha de la reclamo
        const estadoFechaInicio = {
          valor: reclamo.fecha,
          valido: reclamo.fecha ? true : false,
          info: reclamo.fecha ? "" : "La fecha es obligatoria",
        };

        // cargamos el corte con su estado al estado general de la pagina
        const nuevosCortes: InputEstado<Corte>[] = [];

        reclamo.cortesAprobados.forEach((corte: Corte, idx: number) => {
          switch (idx + 1) {
            case 2:
              setMostrarCorte2(true);
              break;
            case 3:
              setMostrarCorte3(true);
              break;
            case 4:
              setMostrarCorte4(true);
              break;
          }

          nuevosCortes.push({
            valor: corte,
            ...estadoValido,
          });
        });

        // cargamos la razon del reclamo
        const razonReclamo = reclamo.reclamo; // Obtén la razón del reclamo desde la respuesta de la API
        setRazon(razonReclamo); 

        // actualizamos el estado de la pagina con los valores calculados arriba
        setPuntoServicio(estadoPuntoServicio);
        setFechaInicio(estadoFechaInicio);
        setCortes(nuevosCortes);
        setEstadoReclamo(reclamo.estado);
      })
      // si hubo algun error en la llamada a la API
      .catch((error) => {
        // presentamos el error con un Toast
        present({
          message: error.response ? error.response.data.error : error,
          duration: 5000,
        });
      });
  };

  // actualizamos el estado de la pagina a su estado inicial, a antes de la carga de datos por marcacion
  const limpiarCampos = () => {
    setPuntoServicio({ valor: undefined, ...estadoInvalido });
    setFechaInicio({ valor: undefined, ...estadoInvalido });
    setRazon('');
    setCortes(estadoInicialCortes);
    setMostrarCorte2(false);
    setMostrarCorte3(false);
    setComentario("");
  };

  // manejamos el cambio en la eleccion de punto de servicio
  // solo checkeamos si la opcion selecta es null
  const handleAutocompleteChange = (opcion: Opcion | null) => {
    const puntoServicio = opcionAPuntoServicio(opcion);

    const estadoPuntoServicio = {
      valor: puntoServicio,
      valido: opcion ? true : false,
      info: opcion ? "" : "El Punto de Servicio es obligatorio",
    };

    setPuntoServicio(estadoPuntoServicio);
  };

  // manejamos el cambio en la eleccion de fecha
  // checkeamos si la fecha selecta es null o si es mayor al momento del cambio
  const handleFechaInicioChange = (date?: Date) => {
    const estadoFechaInicio = {
      valor: date,
      valido: true,
      info: "",
    };

    const hoyYAhora = new Date();

    if (!date) {
      estadoFechaInicio.valido = false;
      estadoFechaInicio.info = "La fecha de entrada es obligatoria";
    } else if (date > hoyYAhora) {
      estadoFechaInicio.valido = false;
      estadoFechaInicio.info = "La fecha debe ser antes de hoy";
    }

    setFechaInicio(estadoFechaInicio);
  };

  // manejamos el cambio en la hora de entrada, para un corte especifico
  const handleHoraEntradaChange = (corteIdx: number, date?: Date) => {
    handleHoraChange("entrada", corteIdx, date);
  };

  // manejamos el cambio en la hora de salida, para un corte especifico
  const handleHoraSalidaChange = (corteIdx: number, date?: Date) => {
    handleHoraChange("salida", corteIdx, date);
  };

  // manejamos el cambio en la hora, para un corte especifico
  // primero checkeamos que los cortes no se solapen, si falla actualizamos su estado
  // si no falla el primer checkeo, checkeamos si la hora es null, es menor/major a su par del corte
  // si falla, actualizamos su estado y si no falla removemos alertas
  const handleHoraChange = (tipo: string, corteIdx: number, date?: Date) => {
    const nuevosCortes = cortes.slice();
    const nuevoCorte = { ...cortes[corteIdx] };

    if (tipo === "entrada")
      nuevoCorte.valor = { ...nuevoCorte.valor, horaEntrada: date };
    else nuevoCorte.valor = { ...nuevoCorte.valor, horaSalida: date };

    const cortePrevio = corteIdx > 0 ? cortes[corteIdx - 1] : undefined;
    const corteSiguiente = corteIdx < 2 ? cortes[corteIdx + 1] : undefined;

    // checkeamos solapamiento entre cortes
    const validacionCortes = checkearValidezDeCorte(
      nuevoCorte,
      cortePrevio,
      corteSiguiente
    );

    // si la valicion de cortes arroja errores, saltamos las pruebas dentro del corte
    if (!validacionCortes.valido) {
      nuevoCorte.valido = validacionCortes.valido;
      nuevoCorte.info = validacionCortes.info;
    } else {
      // si la validacion de cortes no arroja errores, pasamos a las pruebas dentro del corte
      let validacionHoras: InputValidez;
      if (tipo === "entrada") {
        validacionHoras = checkearValidezEntradaSalida(
          date,
          nuevoCorte.valor?.horaSalida
        );

        nuevoCorte.valor = {
          horaEntrada: date,
          horaSalida: nuevoCorte.valor?.horaSalida,
        };
      } else {
        validacionHoras = checkearValidezEntradaSalida(
          nuevoCorte.valor?.horaEntrada,
          date
        );

        nuevoCorte.valor = {
          horaEntrada: nuevoCorte.valor?.horaEntrada,
          horaSalida: date,
        };
      }

      nuevoCorte.valido = validacionHoras.valido;
      nuevoCorte.info = validacionHoras.info;
    }

    nuevosCortes[corteIdx] = nuevoCorte;
    setCortes(nuevosCortes);
  };


  const handleChangeRazon = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedRazon = event.target.value as string; // Obtiene la razón seleccionada del evento
    setRazon(selectedRazon); // Actualiza el estado de razon con la razón seleccionada
  
    // Toggle entre true y false basado en si la opción seleccionada es 'Otros'
    setMostrarComentario((prevMostrarComentario) => selectedRazon === 'Otros' ? !prevMostrarComentario : false);
  };
  

  // habilitamos para carga el siguiente corte, especificamente el primero en estar oculto
  // const handleClickAgregarCorte = () => {
  //   const nuevosCortes = [...cortes];
  //   if (!mostarCorte2) setMostrarCorte2(true);
  //   else if (!mostarCorte3) setMostrarCorte3(true);
  //   else if (!mostarCorte4) setMostrarCorte4(true);
  //   setCortes(nuevosCortes);


  // };

  // si algun corte no es valido, agregamos un error generico si no tiene ninguno aun.
  // esto solo ocurre cuando queremos enviar los datos, para actualizar el error
  const checkeoFinalDeCortes = () => {
    const nuevosCortes = [...cortes];

    if (!cortes[1].valido && !cortes[1].info && mostarCorte2) {
      nuevosCortes[1].info = "Corte incompleto";
    }
    if (!cortes[2].valido && !cortes[2].info && mostarCorte3) {
      nuevosCortes[2].info = "Corte incompleto";
    }
    if (!cortes[3].valido && !cortes[3].info && mostarCorte3) {
      nuevosCortes[3].info = "Corte incompleto";
    }

    setCortes(nuevosCortes);
  };

  // deshabilitamos la carga del corte especificado
  // caso especial: ocultamos un corte, cuando hay cortes posteriores.
  // si ocultamos uno, van en cascada a reemplazarle
  const handleOcultarCorteClick = (corteIdx: number) => {
    let maxIdxActivo = 0;
    if (mostarCorte2) maxIdxActivo++;
    if (mostarCorte3) maxIdxActivo++;
    if (mostarCorte4) maxIdxActivo++;

    const nuevosCortes = cortes.slice();

    // actualizamos la lista de cortes activos
    // (pasamos los datos del corte X al corte X-1 y limpiamos y ocultamos el ultimo corte activo)

    // recorremos los cortes activos desde el que seleccionamos para borrar hasta el penultimo activo
    // les asignamos el valor del sgte
    for (let idx = corteIdx; idx < maxIdxActivo; idx++) {
      nuevosCortes[idx] = nuevosCortes[idx + 1];
    }

    // inactivamos al ultimo de la lista de activos
    nuevosCortes[maxIdxActivo] = { valor: {}, ...estadoInvalido };

    const corte = maxIdxActivo + 1; // para que el indice no sea confuso

    // ocultamos al ultimo activo
    if (corte === 2) setMostrarCorte2(false);
    else if (corte === 3) setMostrarCorte3(false);
    else if (corte === 4) setMostrarCorte4(false);

    // actualizamos la lista de cortes
    setCortes(nuevosCortes);
  };

  // manejamos los botones para reclamar (si se es operario),
  // 1. crear: crear reemplazo sin baserse en las marcaciones
  // 2. cambiar: crear reemplazo basandose en las marcaciones
  // aceptar o rechazar (si se es fiscal)
  // checkeamos antes que todos los datos sean validos
  const handleAccionClick = (operacion: string) => {
    if (operacionEnProceso) return;
    else setOperacionEnProceso(true);

    // resumen de checkeos de cortes visibles y validos
    const cortesNoVacios =
      cortes[0].valido &&
      (!mostarCorte2 || cortes[1].valido) &&
      (!mostarCorte3 || cortes[2].valido) &&
      (!mostarCorte4 || cortes[3].valido);

    // checkeo de validez de todos los inputs
    const formularioValido =
      puntoServicio.valido &&
      fechaInicio.valido &&
      cortesNoVacios &&
      razon;

    // actualizamos los cortes si tienen vacios y visibles
    !cortesNoVacios && checkeoFinalDeCortes();

    // la razon solo puede detectarse su invalidez al querer enviar
    // si es invalida, actualizamos su estado
    !razon &&
      invalidarEstado(setRazon, razon , "La razón es obligatoria");

    // si alguno de los inputs es invalido, no hacer nada
    if (!formularioValido) {
      setOperacionEnProceso(false);
      return;
    }

    // removemos los cortes sin usar del estado antes de enviar
    const cortesValidos = cortes.slice();
    if (!mostarCorte2) cortesValidos.splice(1, 1);
    if (!mostarCorte3) cortesValidos.splice(1, 1);
    if (!mostarCorte4) cortesValidos.splice(1, 1);

    // formateamos el(los) corte(cortes) antes de enviar
    const campoCortes = cortesValidos.map((corte) => corte.valor);

    const marcacion = parseInt(id);
    // finalmente, agrupamos los datos del reclamos a realizar
    const reclamoCuerpo = {
      codigoPuntoServicio: puntoServicio.valor?.codigo,
      nombrePuntoServicio: puntoServicio.valor?.nombre,
      fechaInicio: fechaInicio.valor,
      cortes: campoCortes,
      reclamo: razon,
      comentario: comentario,
      accion: operacion,
    } as ReclamoProceso;

    // solicitamos el proceso del reclamo a la API, en base a la operacion hecha
    ReclamosAPI.procesarReclamo(marcacion, reclamoCuerpo)
      .then(
        // si todo termina bien, vamos a la vista de confirmacion
        (result) => {
          if (result.data.error){
            present({
              message: result.data.error,
              duration: 5000,
            });
          }else{
            present({
              message: result.data.info,
              duration: 5000,
            });
          }
          history.goBack();
        }
      )
      .catch(
        // sino, mostramos el error
        (error) => {
          present({
            message: error.response ? error.response.data.error : error,
            duration: 5000,
          });
        }
      )
      .finally(() => setOperacionEnProceso(false));
  };

  /*******************************************************************************
   * 3. definimos algunas variables/componentes para cargar en la vista y        *
   * procesamos el estado de la pagina para generar contenido acorde en la vista *
   *******************************************************************************/

  // cargamos los detalles para el icono de cerrar la vista
  const botonCerrar = {
    icono: closeOutline,
    action: () => history.goBack(),
  };

  // convertimos el punto de servicio a una opcion valida para el Autocomplete
  const opcion = puntoServicio.valor
    ? {
        id: puntoServicio.valor.codigo,
        nombre: puntoServicio.valor.nombre,
      }
    : null;

  // el titulo antes de los cortes solo se ve para los fiscales, ya que pueden haber varios
  const tituloCortes = esFiscal ? (
    <Typography className="input-width mb-1" variant="subtitle1">
      Cortes
    </Typography>
  ) : null;

  // definimos el estilo del boton para ocultar un cortes
  const estiloOcultarCorte = {
    display: esCargaDeFiscal ? "block" : "none",
    color: "#cf3c4f",
    cursor: "pointer",
    left: "calc(100% + 8px)",
    position: "absolute",
    top: "calc(50% - 10px)",
  };

  // check de si hay aun cortes por mostras, para ocultar el boton de agregar corte
  // const quedanCortes = !(mostarCorte2 && mostarCorte3 && mostarCorte4);

  // establecer las razones predefinidas del reclamo, mas la generica
  const razones = [
    { valor: "Mala marcación", detalles: false },
    { valor: "No funcionaba el marcador", detalles: false },
    {valor: 'No procesó asignación', detalle: false},
    {valor:'Corresponde a hora doble', detalle: false},
    {valor:'Corresponde a hora de feriado', detalle: false},
    {valor:'Corresponde a hora nocturna', detalle: false},
    {valor: 'Corresponde a horas de lavado profundo', detalle: false},
    {valor: 'Problema de conexión/biométrico', detalle: false},
    {valor:'Horas de reemplazo', detalle: false},
    {valor:'Otros', detalle: true},
  ];

 

  // decidimos cuales botones mostrar para confirmar el proceso
  let botonesParaSubmit;

  
  if (esCargaDeFiscal) {
    
    botonesParaSubmit = (
      <IonGrid className="two-columns mb-3">
        <IonRow>
          <IonCol>
            <Button
              className="button input-half-width"
              variant="contained"
              color="primary"
              onClick={() => handleAccionClick("aceptado")}
            >
              aceptar
            </Button>
          </IonCol>

          <IonCol>
            <Button
              className="button input-half-width"
              variant="outlined"
              color="default"
              onClick={() => handleAccionClick("rechazado")}
            >
              rechazar
            </Button>
          </IonCol>
        </IonRow>
      </IonGrid>
    );
  } else if (esCargaDeOperario) {

    botonesParaSubmit = (
      <div className="d-flex justify-content-center mb-3">
        <Button
          className="button input-half-width"
          variant="contained"
          color="primary"
          onClick={() => handleAccionClick(accionDelOperario)}
        >
          reclamar
        </Button>
      </div>
    );
  }

  /***************************
   * 4. template de la vista *
   ***************************/

  return (
    <IonPage>
      <Header titulo="Detalles de Reclamo" botonIzq={botonCerrar} />

      <IonContent>
        <div className="container">
          <div className="d-flex flex-column align-items-center">
            <Typography className="input-width mt-2 mb-2" variant="subtitle1">
              {modoVistaDeOperario
                ? "Horas trabajadas"
                : "Actualizar horas trabajadas"}
            </Typography>

            <Autocomplete
              className="w-help-text"
              label="Punto de Servicio"
              value={opcion}
              setValue={handleAutocompleteChange}
              disabled={!habilitarPSyFecha}
            />
            <HelperText
              texto={puntoServicio.info}
              activo={!puntoServicio.valido}
              tipo="error"
            />

            <DatePicker
              placeholder="Fecha"
              className="w-help-text"
              value={fechaInicio.valor}
              setValue={handleFechaInicioChange}
              maxDate={hoy}
              disabled={!habilitarPSyFecha}
            />
            <HelperText
              texto={fechaInicio.info}
              activo={!fechaInicio.valido}
              tipo="error"
            />

            {tituloCortes}
            <IonGrid className="two-columns relative-rows">
              <IonRow>
                <IonCol>
                  <TimePicker
                    className="half w-help-text"
                    placeholder="Entrada"
                    value={cortes[0].valor?.horaEntrada}
                    setValue={(date) => handleHoraEntradaChange(0, date)}
                    disabled={!modoEdicionGeneral}
                  />
                </IonCol>

                <IonCol>
                  <TimePicker
                    className="half w-help-text"
                    placeholder="Salida"
                    value={cortes[0].valor?.horaSalida}
                    setValue={(date) => handleHoraSalidaChange(0, date)}
                    disabled={!modoEdicionGeneral}
                  />
                </IonCol>

                {/* usamos mostrarCorte2 para asegurar que solo se pueda usar con al menos dos cortes activos */}
                {mostarCorte2 && (
                  <IonIcon
                    onClick={() => handleOcultarCorteClick(0)}
                    icon={closeOutline}
                    size="small"
                    style={estiloOcultarCorte}
                  ></IonIcon>
                )}
              </IonRow>
              <IonRow>
                <IonCol className="p-0">
                  <HelperText
                    className="pl-0"
                    texto={cortes[0].info}
                    activo={!cortes[0].valido}
                    tipo="error"
                  />
                </IonCol>
              </IonRow>

              {mostarCorte2 && (
                <IonRow>
                  <IonCol>
                    <TimePicker
                      className="half w-help-text"
                      placeholder="Entrada 2"
                      value={cortes[1].valor?.horaEntrada}
                      setValue={(date) => handleHoraEntradaChange(1, date)}
                      disabled={!modoEdicionGeneral}
                    />
                  </IonCol>

                  <IonCol>
                    <TimePicker
                      className="half w-help-text"
                      placeholder="Salida 2"
                      value={cortes[1].valor?.horaSalida}
                      setValue={(date) => handleHoraSalidaChange(1, date)}
                      disabled={!modoEdicionGeneral}
                    />
                  </IonCol>

                  <IonIcon
                    onClick={() => handleOcultarCorteClick(1)}
                    icon={closeOutline}
                    size="small"
                    style={estiloOcultarCorte}
                  ></IonIcon>
                </IonRow>
              )}
              {mostarCorte2 && (
                <IonRow>
                  <IonCol className="p-0">
                    <HelperText
                      className="pl-0"
                      texto={cortes[1].info}
                      activo={!cortes[1].valido}
                      tipo="error"
                    />
                  </IonCol>
                </IonRow>
              )}

              {mostarCorte3 && (
                <IonRow>
                  <IonCol>
                    <TimePicker
                      className="half w-help-text"
                      placeholder="Entrada 3"
                      value={cortes[2].valor?.horaEntrada}
                      setValue={(date) => handleHoraEntradaChange(2, date)}
                      disabled={!modoEdicionGeneral}
                    />
                  </IonCol>

                  <IonCol>
                    <TimePicker
                      className="half w-help-text"
                      placeholder="Salida 3"
                      value={cortes[2].valor?.horaSalida}
                      setValue={(date) => handleHoraSalidaChange(2, date)}
                      disabled={!modoEdicionGeneral}
                    />
                  </IonCol>

                  <IonIcon
                    onClick={() => handleOcultarCorteClick(2)}
                    icon={closeOutline}
                    size="small"
                    style={estiloOcultarCorte}
                  ></IonIcon>
                </IonRow>
              )}
              {mostarCorte3 && (
                <IonRow>
                  <IonCol className="p-0">
                    <HelperText
                      className="pl-0"
                      texto={cortes[2].info}
                      activo={!cortes[2].valido}
                      tipo="error"
                    />
                  </IonCol>
                </IonRow>
              )}

              {mostarCorte4 && (
                <IonRow>
                  <IonCol>
                    <TimePicker
                      className="half w-help-text"
                      placeholder="Entrada 4"
                      value={cortes[3].valor?.horaEntrada}
                      setValue={(date) => handleHoraEntradaChange(3, date)}
                      disabled={!modoEdicionGeneral}
                    />
                  </IonCol>

                  <IonCol>
                    <TimePicker
                      className="half w-help-text"
                      placeholder="Salida 4"
                      value={cortes[3].valor?.horaSalida}
                      setValue={(date) => handleHoraSalidaChange(3, date)}
                      disabled={!modoEdicionGeneral}
                    />
                  </IonCol>

                  <IonIcon
                    onClick={() => handleOcultarCorteClick(3)}
                    icon={closeOutline}
                    size="small"
                    style={estiloOcultarCorte}
                  ></IonIcon>
                </IonRow>
              )}
              {mostarCorte4 && (
                <IonRow>
                  <IonCol className="p-0">
                    <HelperText
                      className="pl-0"
                      texto={cortes[3].info}
                      activo={!cortes[3].valido}
                      tipo="error"
                    />
                  </IonCol>
                </IonRow>
              )}
            </IonGrid>
            {/*
            Se comenta por falta de uso
            {esCargaDeFiscal && quedanCortes && (
              <BotonAgregar
                className="mb-2"
                label="AGREGAR CORTE"
                icon={addSharp}
                handleClick={handleClickAgregarCorte}
              />
              )}*/}

              {esCargaDeOperario && (
                <>
                
                

                </>
              )}
            <Typography className="input-width mb-1" variant="subtitle1">
              Razón del reclamo
            </Typography>
           
              <>

              <FormControl className={classes.formControl}>
                <Select
                  className={classes.selectEmpty}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={razon}
                  disabled={!modoEdicionGeneral || esCargaDeFiscal}
                  hidden={!modoEdicionGeneral || esCargaDeFiscal }
                  onChange={handleChangeRazon}
                >
                  {razones.map((razon, index) => (
                    <MenuItem value={razon.valor} key={index}>
                      {razon.valor}
                    </MenuItem>
                  ))}
                </Select>

                
              </FormControl>
                
              </>
            
            
          {mostrarComentario && (
                  <>
                    <Typography className="input-width mb-1" variant="subtitle1">
                      Comentarios
                    </Typography>
                    <TextField
                      className="multiline mb-3"
                      multiline
                      onChange={(event) => setComentario(event.target.value)}
                      placeholder="Escribí acá cualquier detalle que no dijiste aún"
                      rows={3}
                      value={comentario}
                      variant="outlined"
                    />
                  </>
                )}
             

            {!esCargaDeOperario && (
              <Typography
                className="input-width px-2 mb-2"
                variant="body2"
                color="textSecondary"
              >
                {razon}
              </Typography>
            )}


            {modoSoloVistaGeneral && (
              <>
                <Typography className="input-width mb-1" variant="subtitle1">
                  Estado del reclamo
                </Typography>

                <Typography
                  className="input-width px-2 mb-2"
                  variant="body2"
                  color="textSecondary"
                >
                  {estadoReclamo}
                </Typography>
              </>
            )}

            {botonesParaSubmit}

            
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(ReclamoDetalles);

// funcion general para invalidar el estado de un input
function invalidarEstado(
  setter: (valor: any) => void,
  valor: any,
  info: string
) {
  setter({ ...valor, validez: false, info: info });
}
